import React from 'react'
import { useNavigate } from 'react-router-dom'
import Header from './Header'

export default function Visa() {
    const navigate=useNavigate()
  return (
    <div>
    <Header />
     <h1>Visa</h1>
   <div className="container display-flex" style={{display:'flex',marginTop:'100px'}}>
   <div class="col-md-4 mb-3" style={{marginLeft:'200px',marginRight:'20px'}}>
      <div class="card">
        <img
          class="img-fluid"
          alt="100%x280"
          src="https://www.allimmigration.com.au/ressources/images/9d617cd05947.jpg"
          style={{ width: "500px", height: "300px" }}
        />
        <div class="card-body">
          <h2 class="card-title">Work Visa</h2>
          {/* <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> */}
        </div>
      </div>
    </div>
    <div class="col-md-4 mb-3 ">
      <div class="card">
        <img
          class="img-fluid"
          alt="100%x280"
          src="https://th.bing.com/th/id/OIP.lFeP1wLWQnvOoJJoE3rwzgHaEE?w=273&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7"
          style={{ width: "500px", height: "300px" }}
        />
        <div class="card-body">
          <h2 class="card-title">Tourist Visa</h2>
          {/* <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> */}
        </div>
      </div>
    </div>
   </div>
  </div>
  )
}
